import { useList } from '../../../api/react-query';
import { useApp } from '../../../context';

export function useAllowanceTypeList(props) {
  const { companyId } = useApp();
  const { data, isLoading } = useList(
    'getAllowanceTypes',
    { company_id: companyId, ...props?.params },
    '',
    'v1',
  );
  return { data: data?.data?.data, isLoading, count: data?.data?.total || data?.data?.data?.length };
}
